import { OrganizationsApi, SsoApi, UsersApi, NotificationAssignApi,  Configuration as UserClientConfig, OptionsApi, CloudSubscriptionsApi, DeviceApi, ClientApi, ReleaseApi } from '@/gen/api/user'
import { BackupApi, DatabasesApi, Configuration as BackupClientConfig } from '@/gen/api/backup'
import { Configuration as MetricsClientConfig, MetricsApi } from '@/gen/api/metrics'
import { Configuration as EncryptClientConfig, EncryptionsApi, EncryptionKeysApi, MappingsApi, ObfuscationApi, FileEncryptionApi, SubsetApi, DataAnalyzeApi as EncryptDataAnalyzeApi } from '@/gen/api/encrypt'
import { Configuration as DeployClientConfig, DeploymentsApi, NetworkConnectionsApi, NetworkGatewaysApi } from '@/gen/api/deploy'
import { Configuration as FileClientConfig, FilesApi } from '@/gen/api/file'
import { Configuration as SecureFileClientConfig, SecureFilesApi } from '@/gen/api/securefile'
import { Configuration as SecureAIClientConfig, SecureAIApi } from '@/gen/api/secureai'
import { Configuration as GovernanceClientConfig, 
  DataAccessRolesApi, SecondaryClassificationsApi, FieldTagsApi, GovernanceDashboardApi,
  OptionsApi as GovrnOptionsApi, FieldsApi, RetentionRuleApi, ReasonCollectApi, DataOwnerGroupsApi, 
  SemanticApi} from '@/gen/api/governance'
import axios from './axios'
import authProvider from '@/authProvider/authProvider'

const userBasePath = import.meta.env.VITE_BACKEND_USER_API_BASEURL || 'http://localhost:5000'
const backupBasePath = import.meta.env.VITE_BACKEND_BACKUP_API_BASEURL || 'http://localhost:5000'
const metricsBasePath = import.meta.env.VITE_BACKEND_METRICS_API_BASEURL || 'http://localhost:5000'
const encryptBasePath = import.meta.env.VITE_BACKEND_ENCRYPT_API_BASEURL || 'http://localhost:5000'
const deployBasePath = import.meta.env.VITE_BACKEND_DEPLOY_API_BASEURL || 'http://localhost:5000'
const fileBasePath = import.meta.env.VITE_BACKEND_FILE_API_BASEURL || 'http://localhost:5000'
const secureFileBasePath = import.meta.env.VITE_BACKEND_SECUREFILE_API_BASEURL || 'http://localhost:5000'
const secureAIBasePath = import.meta.env.VITE_BACKEND_SECUREAI_API_BASEURL || 'http://localhost:5000'
const governanceBasePath = import.meta.env.VITE_BACKEND_GOVERNANCE_API_BASEURL || 'http://localhost:5000'
const tokenConfigPortion = {
  accessToken: () => authProvider.userManager.getUser().then(user => user?.access_token || ''),
}

const uConfig = new UserClientConfig({
  ...tokenConfigPortion,
  basePath: userBasePath,
})
const bConfig = new BackupClientConfig({
  ...tokenConfigPortion,
  basePath: backupBasePath,
})
const mConfig = new MetricsClientConfig({
  ...tokenConfigPortion,
  basePath: metricsBasePath,
})
const eConfig = new EncryptClientConfig({
  ...tokenConfigPortion,
  basePath: encryptBasePath,
})
const dConfig = new DeployClientConfig({
  ...tokenConfigPortion,
  basePath: deployBasePath,
})
const fConfig = new FileClientConfig({
  ...tokenConfigPortion,
  basePath: fileBasePath,
})
const gConfig = new GovernanceClientConfig({
  ...tokenConfigPortion,
  basePath: governanceBasePath,
})
const sConfig = new SecureFileClientConfig({
  ...tokenConfigPortion,
  basePath: secureFileBasePath,
})
const saiConfig = new SecureAIClientConfig({
  ...tokenConfigPortion,
  basePath: secureAIBasePath,
})

export const organizationApiClient : OrganizationsApi = new OrganizationsApi(uConfig, userBasePath, axios)
export const ssoApiClient : SsoApi = new SsoApi(uConfig, userBasePath, axios)
export const deviceApiClient : DeviceApi = new DeviceApi(uConfig, userBasePath, axios)
export const cloudSubscriptApiClient : CloudSubscriptionsApi = new CloudSubscriptionsApi(uConfig, userBasePath, axios)
export const userApiClient : UsersApi = new UsersApi(uConfig, userBasePath, axios)
export const clientApiClient : ClientApi = new ClientApi(uConfig, userBasePath, axios)
export const optionsApiClient : OptionsApi = new OptionsApi(uConfig, userBasePath, axios)
export const notiAssignApiClient : NotificationAssignApi = new NotificationAssignApi(uConfig, userBasePath, axios)
export const releaseApiClient : ReleaseApi = new ReleaseApi(uConfig, userBasePath, axios)


export const backupApiClient: BackupApi = new BackupApi(bConfig, backupBasePath, axios)
export const databasesApiClient: DatabasesApi = new DatabasesApi(bConfig, backupBasePath, axios)

export const metricsApiClient: MetricsApi = new MetricsApi(mConfig, metricsBasePath, axios)

export const encryptApiClient: EncryptionsApi = new EncryptionsApi(eConfig, encryptBasePath, axios)
export const encryptKeyApiClient: EncryptionKeysApi = new EncryptionKeysApi(eConfig, encryptBasePath, axios)
export const mappingsApiClient: MappingsApi = new MappingsApi(eConfig, encryptBasePath, axios)
export const obfsApiClient: ObfuscationApi = new ObfuscationApi(eConfig, encryptBasePath, axios)
export const fileEncryptApiClient: FileEncryptionApi = new FileEncryptionApi(eConfig, encryptBasePath, axios)
export const subsetApiClient: SubsetApi = new SubsetApi(eConfig, encryptBasePath, axios)
export const encryptDataAnalyzeApiClient: EncryptDataAnalyzeApi = new EncryptDataAnalyzeApi(eConfig, encryptBasePath, axios)

export const deployApiClient: DeploymentsApi = new DeploymentsApi(dConfig, deployBasePath, axios)
export const networkConnApiClient: NetworkConnectionsApi = new NetworkConnectionsApi(dConfig, deployBasePath, axios)
export const gatewayApiClient: NetworkGatewaysApi = new NetworkGatewaysApi(dConfig, deployBasePath, axios)

export const fileApiClient: FilesApi = new FilesApi(fConfig, fileBasePath, axios)
export const secureFileApiClient: SecureFilesApi = new SecureFilesApi(sConfig, secureFileBasePath, axios)

export const secureAIApiClient: SecureAIApi = new SecureAIApi(saiConfig, secureAIBasePath, axios)

export const dataAccessRoleApiClient: DataAccessRolesApi = new DataAccessRolesApi(gConfig, governanceBasePath, axios)
export const subClsApiClient: SecondaryClassificationsApi = new SecondaryClassificationsApi(gConfig, governanceBasePath, axios)
export const tagsApiClient: FieldTagsApi = new FieldTagsApi(gConfig, governanceBasePath, axios)
export const govrnOptionsApiClient: GovrnOptionsApi = new GovrnOptionsApi(gConfig, governanceBasePath, axios)
export const fieldsApiClient: FieldsApi = new FieldsApi(gConfig, governanceBasePath, axios)
export const retentionRuleApiClient: RetentionRuleApi = new RetentionRuleApi(gConfig, governanceBasePath, axios)
export const reasonCollectApiClient: ReasonCollectApi = new ReasonCollectApi(gConfig, governanceBasePath, axios)
export const dataOwnerGroupApiClient: DataOwnerGroupsApi = new DataOwnerGroupsApi(gConfig, governanceBasePath, axios)
export const govncDashboardApiClient: GovernanceDashboardApi = new GovernanceDashboardApi(gConfig, governanceBasePath, axios)
export const govncSemanticApiClient: SemanticApi = new SemanticApi(gConfig, governanceBasePath, axios)

